import api from "./api";

export interface BrokerSettings {
  zerodha?: {
    apiKey: string;
    apiSecret: string;
    accessToken?: string;
    lastLogin?: string;
  };
  ibkr?: {
    host?: string;
    port?: number;
    clientId?: number;
  };
}

export interface TradeSettings {
  ind: {
    capital: number;
    baseRisk: number;
    autoTradeEnabled: boolean;
    emergencyHalt?: boolean;
  };
  us: {
    capital: number;
    baseRisk: number;
    autoTradeEnabled: boolean;
    emergencyHalt?: boolean;
  };
}

export interface User {
  id: string;
  _id: string;
  name: string;
  email: string;
  role: "admin" | "viewer";
  createdAt: string;
  lastLogin?: string;
  brokerSettings?: BrokerSettings;
  tradeSettings?: TradeSettings;
  isZerodhaLinked?: boolean;
  hasBrokerSettings?: boolean;
}

export const updateBrokerSettings = async (settings: BrokerSettings) => {
  try {
    const response = await api.put("/auth/broker-settings", {
      apiKey: settings.zerodha?.apiKey,
      apiSecret: settings.zerodha?.apiSecret,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating broker settings", error);
    throw error;
  }
};

export const fetchUserSettings = async () => {
  try {
    const response = await api.get("/auth/user");
    return response.data;
  } catch (error) {
    console.error("Error fetching user settings", error);
    throw error;
  }
};

// Admin User Management API Calls
export const fetchAllUsers = async (): Promise<User[]> => {
  try {
    const response = await api.get("/auth/users");
    return response.data;
  } catch (error) {
    console.error("Error fetching all users", error);
    throw error;
  }
};

export const createUser = async (userData: Partial<User> & { password?: string }): Promise<any> => {
  try {
    const response = await api.post("/auth/users", userData);
    return response.data;
  } catch (error) {
    console.error("Error creating user", error);
    throw error;
  }
};

export const updateUser = async (userId: string, userData: Partial<User>): Promise<any> => {
  try {
    const response = await api.put(`/auth/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error("Error updating user", error);
    throw error;
  }
};

export const changeUserPassword = async (userId: string, passwordData: { password?: string }): Promise<any> => {
  try {
    const response = await api.put(`/auth/users/${userId}/password`, passwordData);
    return response.data;
  } catch (error) {
    console.error("Error changing user password", error);
    throw error;
  }
};

export const deleteUser = async (userId: string): Promise<any> => {
  try {
    const response = await api.delete(`/auth/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user", error);
    throw error;
  }
};

